export const getSefiUserId = () => {
  const fromStorage = localStorage.getItem('user_id');
  if (fromStorage && fromStorage !== 'null') return fromStorage;
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u?.user_id ?? u?.id ?? null;
  } catch {
    return null;
  }
};

const LAST_CHAT_SESSION_KEY = 'sefi_last_chat_session';

/** Persist last active AI chat so reopen resumes the same session. */
export const getLastChatSession = () => {
  try {
    const raw = localStorage.getItem(LAST_CHAT_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.sessionId ? parsed : null;
  } catch {
    return null;
  }
};

export const saveLastChatSession = (sessionId, projectId = null) => {
  if (!sessionId) {
    localStorage.removeItem(LAST_CHAT_SESSION_KEY);
    return;
  }
  localStorage.setItem(
    LAST_CHAT_SESSION_KEY,
    JSON.stringify({ sessionId, projectId: projectId || null })
  );
};

export const clearLastChatSession = () => {
  localStorage.removeItem(LAST_CHAT_SESSION_KEY);
};

export const sefiAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  if (!token || token === 'null' || token === 'undefined') return {};
  return { Authorization: `Bearer ${token}` };
};

/** JWT + user_id query (same pattern as other ticket APIs). */
export const sefiRequestConfig = () => {
  const userId = getSefiUserId();
  return {
    headers: sefiAuthHeaders(),
    params: userId ? { user_id: userId } : {},
  };
};
